import { render, staticRenderFns } from "./ViewProcessInstance.vue?vue&type=template&id=13b0a406&"
import script from "./ViewProcessInstance.vue?vue&type=script&lang=js&"
export * from "./ViewProcessInstance.vue?vue&type=script&lang=js&"
import style0 from "./ViewProcessInstance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports